import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of } from 'rxjs';
import * as InvoiceActions from './invoice.actions';
import InvoiceService from '../../services/InvoiceService';

@Injectable()
export class InvoiceEffects {
  loadInvoices$;
  selectInvoice$;
  constructor(
    private actions$: Actions,
    private invoiceService: InvoiceService
  ) {
    this.loadInvoices$ = createEffect(() =>
      this.actions$.pipe(
        ofType(InvoiceActions.getInvoices),
        mergeMap(({ customerNo }) =>
          this.invoiceService.getInvoices(customerNo).pipe(
            map((invoices) => InvoiceActions.getInvoicesSuccess({ invoices })),
            catchError(() => of(InvoiceActions.getInvoicesFailure()))
          )
        )
      )
    );
    this.selectInvoice$ = createEffect(() =>
      this.actions$.pipe(
        ofType(InvoiceActions.selectInvoice),
        mergeMap(({ orderNo, customerNo }) =>
          this.invoiceService.getInvoiceByOrderNo(orderNo, customerNo).pipe(
            map((invoice) => InvoiceActions.selectInvoiceSuccess({ invoice })),
            catchError(() => of(InvoiceActions.selectInvoiceFailure()))
          )
        )
      )
    );
  }
}
